import React, {useRef} from 'react';
import { useDownloadExcel } from 'react-export-table-to-excel';

const TestExcel = () =>  {
    const tableRef = useRef(null);

    const { onDownload } = useDownloadExcel({
        currentTableRef: tableRef.current,
        filename: 'Users table',
        sheet: 'Users'
    })

        return (
            <div>
                <button className='bg-green-500 text-white rounded-xl px-6 h-[50px]' onClick={onDownload}> Export excel </button>

                <div className="table-responsive">
                 <table  ref={tableRef}>
                  <tbody>
                    <tr>
                        <th>Firstname</th>
                        <th>Lastname</th>
                        <th>Age</th>
                    </tr>
                    <tr>
                        <td>Edison</td>
                        <td>Padilla</td>
                        <td>20</td>
                    </tr>
                    <tr>
                        <td>Alberto</td>
                        <td>Lopez</td>
                        <td>94</td>
                    </tr>
                  </tbody>
                </table>
                </div>

            </div>
        );
    }


export default TestExcel